import React, { Fragment } from 'react';

const values = ['რბილი შეხება', 'დიდი ფანტაზია', 'პატარა ბედნიერება', 'რბილი შეხება', 'დიდი ფანტაზია'];

export default function Marquee() {
  return (
    <section className="kido-marquee" aria-label="KIDO values">
      <div>
        {values.map((text, i) => (
          <Fragment key={i}>
            <span>{text}</span>{i < values.length - 1 && <b>✳</b>}
          </Fragment>
        ))}
      </div>
    </section>
  );
}
